module.exports = __webpack_public_path__ + "img/gentileza.fd250f75.jpg";